import WholePage from "./pages/WholePage";
import ThankYou from "./pages/ThankYou";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./index.css";

function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/" component={WholePage}></Route>
          <Route exact path="/podminky-akce" component={ThankYou}></Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
